import { getName } from './getName';
export const generateMetric = aggregationConfig => {
  return {
    property: aggregationConfig.property,
    name: getName(aggregationConfig),
    metricTypes: [aggregationConfig.aggregation]
  };
};